<template>
  <div>
    <!-- About -->
    <section id="about" class="section-1 highlights team image-right">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-8 align-self-top text">
                    <div class="row mb-40">
                          <div class="site-title">
                            <h4 class="sub-title">
                              {{oneData.heading}}
                              
                            </h4>
                            <h2>{{oneData.title}}</h2>
                          </div>
                    </div>
                    <div class="row">
                        <div class="col-12 pr-md-5 about-mision">
                            <p>{{oneData.desc}}</p>
                        </div>
                    </div>
                </div>
                <div data-aos="zoom-in" class="col-12 col-lg-4">
                    <div class="quote mt-5 mt-lg-0">
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item d-flex justify-content-center align-items-center">
                                <a href="#"><i :class="oneData.icon_one"></i></a>
                                <div class="list-group-content">
                                    <h4>{{oneData.title_one}}</h4>
                                    <p>{{one}}<br><strong data-toggle="modal" data-target="#exampleModalCenter">[...]</strong></p>
                                </div>
                            </li>
                            <li class="list-group-item d-flex justify-content-center align-items-center">
                                <a href="#"><i class="fa fa-bullseye" aria-hidden="true"></i></a>
                                <div class="list-group-content">
                                    <h4>{{oneData.title_two}}</h4>
                                    <p>{{oneData.desc_two}}</p>
                                </div>
                            </li>
                            <li class="list-group-item d-flex justify-content-center align-items-center">
                                <a href="#"><i class="fas fa-rocket"></i></a>
                                
                                <div class="list-group-content">
                                    <h4>{{oneData.title_three}}</h4>
                                    <p>{{three}}<br><strong data-toggle="modal" data-target="#exampleModalCenter3">[...]</strong></p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="exampleModalLongTitle">{{oneData.title_one}}</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>{{oneData.desc_one}}</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="exampleModalCenter3" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="exampleModalLongTitle">{{oneData.title_three}}</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
          <p>{{oneData.desc_three}}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            
          </div>
        </div>
      </div>
      </div>
    </section>
    
     <!-- About 2 -->
    <section id="about-2" class="section-2 odd highlights image-right counter funfacts featured">
      <div class="container">
      <div class="row">
          <div class="col-12 col-md-6 pr-md-5 align-self-top text">
              <div data-aos="fade-up"  class="row intro m-0 m-md-auto">
                  <div class="col-12 p-0">
                    <div class="col-12 p-0">
                      <div class="site-title">
                        <h2>{{two.title}}</h2>
                      </div>
                    </div>
                      
                      <p>{{two.desc_1}}</p>
                      <p>{{two.desc_2}}.</p>
                      
                      
                  </div>
              </div>
          </div>
          <div class="col-12 col-md-6 pr-md-5 align-self-top text">
              <div v-if="thangCounter == true" class="row items">
                  <div data-aos="fade-up" class="col-12 col-md-6 p-0 pr-md-4 mb-2 counter-item">
                      <div data-percent="128" class="radial left">
                         <span> <countTo :startVal='startVal' :endVal='parseInt(two.title_one_no, 10)' :duration='4000'></countTo></span>
                      </div>
                      <h4>{{two.title_one}}</h4>
                      <p>{{two.desc_one}} </p>
                  </div>
                  <div data-aos="fade-up" class="col-12 col-md-6 p-0 pr-md-4 mb-2 counter-item">
                      <div data-percent="230" class="radial left">
                          <countTo :startVal='0' :endVal='parseInt(two.title_two_no, 10)' :duration='4000'></countTo>
                      </div>
                      <h4>{{two.title_two}}</h4>
                      <p>{{two.desc_two}}.</p>
                  </div>
                    <div data-aos="fade-up" class="col-12 col-md-6 p-0 pr-md-4 mb-2 counter-item">
                      <div data-percent="230" class="radial left">
                          <countTo :startVal='0' :endVal='parseInt(two.title_three_no, 10)' :duration='4000'></countTo>
                      </div>
                      <h4>{{two.title_three}}</h4>
                      <p>{{two.desc_three}}. </p>
                  </div>
                    <div data-aos="fade-up" class="col-12 col-md-6 p-0 pr-md-4 mb-2 counter-item">
                      <div data-percent="230" class="radial left">
                          <countTo :startVal='0' :endVal='parseInt(two.title_four_no, 10)' :duration='4000'></countTo>
                      </div>
                      <h4>{{two.title_four}}</h4>
                      <p>{{two.desc_four}}. </p>
                  </div>
              </div>

              <div v-else class="row items">
                  <div data-aos="fade-up" class="col-12 col-md-6 p-0 pr-md-4 mb-2 counter-item">
                      <div data-percent="128" class="radial left">
                          <!-- <countTo :startVal='startVal' :endVal='parseInt(two.title_one_no, 10)' :duration='4000'></countTo> -->
                          {{two.title_one_no}}
                      </div>
                      <h4>{{two.title_one}}</h4>
                      <p>{{two.desc_one}} </p>
                  </div>
                  <div data-aos="fade-up" class="col-12 col-md-6 p-0 pr-md-4 mb-2 counter-item">
                      <div data-percent="230" class="radial left">
                          <!-- <countTo :startVal='0' :endVal='parseInt(two.title_two_no, 10)' :duration='4000'></countTo> -->
                          {{two.title_two_no}}
                      </div>
                      <h4>{{two.title_two}}</h4>
                      <p>{{two.desc_two}}.</p>
                  </div>
                    <div data-aos="fade-up" class="col-12 col-md-6 p-0 pr-md-4 mb-2 counter-item">
                      <div data-percent="230" class="radial left">
                          <!-- <countTo :startVal='0' :endVal='parseInt(two.title_three_no, 10)' :duration='4000'></countTo> -->
                          {{two.title_three_no}}
                      </div>
                      <h4>{{two.title_three}}</h4>
                      <p>{{two.desc_three}}. </p>
                  </div>
                    <div data-aos="fade-up" class="col-12 col-md-6 p-0 pr-md-4 mb-2 counter-item">
                      <div data-percent="230" class="radial left">
                          <!-- <countTo :startVal='0' :endVal='parseInt(two.title_four_no, 10)' :duration='4000'></countTo> -->
                          {{two.title_four_no}}
                      </div>
                      <h4>{{two.title_four}}</h4>
                      <p>{{two.desc_four}}. </p>
                  </div>
              </div>
          </div>
      </div>
      </div>
    </section>

    <!-- About 3 -->
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-sm-offset-1 col-md-offset-0 col-md-12 col-xs-12 ">
                <div class="documentories_area clearfix">
                    <ul :class="{'bounce animated': animated}">
                        <li class="single_documentories " v-for="d in docData" :key="d.id">
                            <div class="single_documentories_wrapper">
                                <div class="documentories_year  animated reveal" data-anim-duration="0.3s" data-anim="fadeInUp" data-anim-delay="0.2s">{{ d.ym }}</div>
                                
                                <div class="documentories_content_wrapper bounce  animated reveal" data-anim-duration="0.3s" data-anim="fadeInUp" data-anim-delay="0.2s">
                                    <div class="documentories_text">
                                        <p>{{d.desc}} </p>
                                    </div>
                                    <div class="documentories_img">
                                        <img :src="url + d.image" alt="Image">
                                    </div>
                                </div>
                            </div>
                        </li>
                      <div class="prenext d-flex justify-content-center">
                          <div class="previous_timelin">
                              <a href="#" class="btn_effect" @click.prevent="prev">{{tObject.prev}}</a>
                          </div>
                          <div class="next_timelin">
                              <a href="#" class="btn_effect" @click.prevent="next">{{tObject.next}}</a>
                          </div>
                      </div>

                    </ul>
                </div>

            </div>
            <!-- column end -->
        </div>
        <!-- row end -->
    </div>

   <!-- About 4 -->
    <section class="corporate-video">
        <div class="container">
            <div class="row">
              <div class="col-md-12 justify-content-center">
                <div class="site-title">
                  <h2 v-if="enableEnglish == true">Corporate Videos</h2>
                  <h2 v-if="enableArabic == true">فيديوهات الشركات</h2>
                  <h2 v-if="enableFrench == true">Vidéos d'entreprise</h2>
                  <p v-if="enableEnglish == true">Explore more about Bengal Group of Industries</p>
                  <p v-if="enableArabic == true">اكتشف المزيد عن مجموعة بنغال للصناعات</p>
                  <p v-if="enableFrench == true">En savoir plus sur Bengal Group of Industries</p>
                </div>
              </div>
            </div>  
            <div class="row">
              <div class="col-sm-12 corporate-video-tab">
                <ul class="nav nav-tabs d-flex justify-content-center" id="myTab" role="tablist">
                  <li class="nav-item" @click.prevent="clkCor">
                    <a v-if="enableEnglish == true" :class="corStyle" href >Corprate Video</a>
                    <a v-if="enableArabic == true" :class="corStyle" href>شركات الفيديو</a>
                    <a v-if="enableFrench == true" :class="corStyle" href>Vidéo d'entreprise</a>
                  </li>
                  <li class="nav-item">
                    <a v-if="enableEnglish == true" :class="topStyle"  @click.prevent="clkTop" href>Top Management Video</a>
                    <a v-if="enableArabic == true" :class="topStyle"  @click.prevent="clkTop" href>فيديو الإدارة العليا</a>
                    <a v-if="enableFrench == true" :class="topStyle" @click.prevent="clkTop" href>Vidéo de gestion supérieure</a>
                  </li>
                  
                </ul>
                <div class="col-lg-12 col-md-12 col-sm-12 video-column" v-if="enableCor == true">
                      <div id="video_block_1" class="video-inner">
                          <div class="video-inner" :style="`background-image: url(${url + corporate.image})`">
                              <a @click.prevent="showModal=true" :href="corporate.link" class="lightbox-image">
                                  <i class="fas fa-play"></i>
                                </a>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 video-column" v-if="enableTop == true">
                      <div id="video_block_1">
                          <div class="video-inner" :style="`background-image: url(${url + management.image})`">
                              <a @click.prevent="showModal=true" :href="management.link" class="lightbox-image">
                                  <i class="fas fa-play"></i>
                                </a>
                          </div>
                      </div>
                  </div>
                
              </div>
            </div>

            <Modal v-model="showModal">
              <iframe v-if="showModal == true" class="embed-responsive-item" :src=" utvUrl + '?autoplay=1&showinfo=0&modestbranding=1&rel=0&mute=0'" width=600px height=330px allowfullscreen  allowscriptaccess="always"  allow="autoplay"></iframe>
            </Modal>  
      </div>
    </section>


  </div>
</template>

<script>
import axios from 'axios'
import VueModal from '@kouts/vue-modal'
import '@kouts/vue-modal/dist/vue-modal.css'
import countTo from 'vue-count-to';
export default {
  components: { countTo, 'Modal': VueModal  },
  props: ['ul'],
  created(){
      this.getVideoLink()
      //this.getContentOne()
      //this.getContentTwo()
      //this.getContentThree()

      if(this.ul.lang){
        if(this.ul.lang == 'Arabic'){
          this.thangCounter = false
          this.getContentOne()
          this.getContentTwo()
          this.getContentThree()
          this.enableEnglish = false
          this.enableArabic = true
          this.enableFrench = false
        }else if(this.ul.lang == 'English'){
          this.thangCounter = true
          this.getContentOne()
          this.getContentTwo()
          this.getContentThree()
          this.enableEnglish = true
          this.enableArabic = false
          this.enableFrench = false
        }else{
          this.thangCounter = false
          this.getContentOne()
          this.getContentTwo()
          this.getContentThree()
          this.enableEnglish = false
          this.enableArabic = false
          this.enableFrench = true
        }
      }else{
        this.getContentOne()
        this.getContentTwo()
        this.getContentThree()
        this.enableEnglish = true
        this.enableArabic = false
        this.enableFrench = false
      }

      this.$root.$on('english', (e) => {
          this.thangCounter = true
          this.form.lang = e
          this.getContentOne()
          this.getContentTwo()
          this.getContentThree()
          this.enableEnglish = true
          this.enableArabic = false
          this.enableFrench = false
      })



      this.$root.$on('arabic', (e) => {
          this.thangCounter = false
          this.form.lang = e
          this.getContentOne()
          this.getContentTwo()
          this.getContentThree()
          this.enableEnglish = false
          this.enableArabic = true
          this.enableFrench = false
      })

      this.$root.$on('french', (e) => {
          this.thangCounter = false
          this.form.lang = e
          this.getContentOne()
          this.getContentTwo()
          this.getContentThree()
          this.enableEnglish = false
          this.enableArabic = false
          this.enableFrench = true
      })

     
  },
  data () {
    return {
      url: this.ul.url,
      showModal: false,
      enableEnglish: true,
      enableArabic: false,
      enableFrench: false,
      startVal: 0,
      endVal: '',
      docData: [],
      oneData: {},
      loadData: [],
      utvUrl: 'https://www.youtube.com/embed/5SdvdmeCsOs',
      page: 1,
      form: {
          lang: this.ul.lang
      },
      corporate: {},
      management: {},
      animated: false,
      one: '',
      two: {},
      three: '',
      tObject: {},
      enableCor: true,
      enableTop: false,
      corStyle: 'nav-link active',
      topStyle: 'nav-link',
      thangCounter: true
    }
  },
  methods: {
      clkCor(){
        this.enableCor = true
        this.enableTop = false
        this.corStyle = 'nav-link active'
        this.topStyle = 'nav-link'
      },
      clkTop(){
        this.enableCor = false
        this.enableTop = true
        this.corStyle = 'nav-link'
        this.topStyle = 'nav-link active'
      },
      getVideoLink(){
          axios.get(this.url + 'api/getYoutubeLink')
          .then(({data}) => {
              this.corporate = data.corporate
              this.management = data.management
          })
      },
      getContentOne(){
          axios.get(this.url + 'api/getContentOne', {params: this.form})
              .then(({data}) => {
                  this.oneData = data
                  this.one = data.desc_one.substring(0,100)
                  this.three = data.desc_three.substring(0,100)
              })
      },
      getContentTwo(){
          axios.get(this.url + 'api/getContentTwo', {params: this.form})
              .then(({data}) => {
                  this.two = data
              })
      },
      getContentThree(page){
         axios.get(this.url + 'api/getContentThree?page=' + page, {params: this.form})
          .then(({data}) => {
              this.docData = ''
              this.docData = data.data
              if(this.page == 1){
                  this.loadData = data.data
                  this.tObject = this.loadData[0]
              }
            //console.log(this.tObject)
          })
      },
      chrmClick(){
          this.$emit('chairman', this.utvUrl)
      },
      next(){
          this.page = this.page + 1
          axios.get(this.url + 'api/getContentThree?page=' + this.page, {params: this.form})
          .then(({data}) => {
            if(data.data.length > 1){
              this.docData = ''
              this.docData = data.data
              var self = this;
              self.animated = true;
              setTimeout(function(){ self.animated = false; }, 1000);
            }else{
              this.docData = ''
              this.docData = this.loadData
              this.page = 1
              self.animated = true;
              setTimeout(function(){ self.animated = false; }, 1000);
            }
          })
      },
      prev(){
          this.page = this.page - 1
          axios.get(this.url + 'api/getContentThree?page=' + this.page, {params: this.form})
          .then(({data}) => {
            if(this.page == 0){
              this.page = 1
            }else{
              this.docData = ''
              this.docData = data.data
              var self = this;
              self.animated = true;
              setTimeout(function(){ self.animated = false; }, 1000);
              console.log(data.data)
            }
          })
      }
  }
}
</script>

<style scoped>
@charset "UTF-8";

/*!
* animate.css -http://daneden.me/animate
* Version - 3.5.1
* Licensed under the MIT license - http://opensource.org/licenses/MIT
*
* Copyright (c) 2016 Daniel Eden
*/

.animated {
-webkit-animation-duration: 1s;
animation-duration: 1s;
-webkit-animation-fill-mode: both;
animation-fill-mode: both;
}

.animated.infinite {
-webkit-animation-iteration-count: infinite;
animation-iteration-count: infinite;
}

.animated.hinge {
-webkit-animation-duration: 2s;
animation-duration: 2s;
}

.animated.flipOutX,
.animated.flipOutY,
.animated.bounceIn,
.animated.bounceOut {
-webkit-animation-duration: .75s;
animation-duration: .75s;
}

@-webkit-keyframes bounce {
from, 20%, 53%, 80%, to {
  -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
}

40%, 43% {
  -webkit-animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  -webkit-transform: translate3d(0, -30px, 0);
  transform: translate3d(0, -30px, 0);
}

70% {
  -webkit-animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  -webkit-transform: translate3d(0, -15px, 0);
  transform: translate3d(0, -15px, 0);
}

90% {
  -webkit-transform: translate3d(0,-4px,0);
  transform: translate3d(0,-4px,0);
}
}

@keyframes bounce {
from, 20%, 53%, 80%, to {
  -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  -webkit-transform: translate3d(0,0,0);
  transform: translate3d(0,0,0);
}

40%, 43% {
  -webkit-animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  -webkit-transform: translate3d(0, -30px, 0);
  transform: translate3d(0, -30px, 0);
}

70% {
  -webkit-animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  animation-timing-function: cubic-bezier(0.755, 0.050, 0.855, 0.060);
  -webkit-transform: translate3d(0, -15px, 0);
  transform: translate3d(0, -15px, 0);
}

90% {
  -webkit-transform: translate3d(0,-4px,0);
  transform: translate3d(0,-4px,0);
}
}

.bounce {
-webkit-animation-name: bounce;
animation-name: bounce;
-webkit-transform-origin: center bottom;
transform-origin: center bottom;
}

@-webkit-keyframes flash {
from, 50%, to {
  opacity: 1;
}

25%, 75% {
  opacity: 0;
}
}

@keyframes flash {
from, 50%, to {
  opacity: 1;
}

25%, 75% {
  opacity: 0;
}
}

.flash {
-webkit-animation-name: flash;
animation-name: flash;
}

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */

@-webkit-keyframes pulse {
from {
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}

50% {
  -webkit-transform: scale3d(1.05, 1.05, 1.05);
  transform: scale3d(1.05, 1.05, 1.05);
}

to {
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}
}

@keyframes pulse {
from {
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}

50% {
  -webkit-transform: scale3d(1.05, 1.05, 1.05);
  transform: scale3d(1.05, 1.05, 1.05);
}

to {
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}
}

.pulse {
-webkit-animation-name: pulse;
animation-name: pulse;
}

@-webkit-keyframes rubberBand {
from {
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}

30% {
  -webkit-transform: scale3d(1.25, 0.75, 1);
  transform: scale3d(1.25, 0.75, 1);
}

40% {
  -webkit-transform: scale3d(0.75, 1.25, 1);
  transform: scale3d(0.75, 1.25, 1);
}

50% {
  -webkit-transform: scale3d(1.15, 0.85, 1);
  transform: scale3d(1.15, 0.85, 1);
}

65% {
  -webkit-transform: scale3d(.95, 1.05, 1);
  transform: scale3d(.95, 1.05, 1);
}

75% {
  -webkit-transform: scale3d(1.05, .95, 1);
  transform: scale3d(1.05, .95, 1);
}

to {
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}
}

@keyframes rubberBand {
from {
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}

30% {
  -webkit-transform: scale3d(1.25, 0.75, 1);
  transform: scale3d(1.25, 0.75, 1);
}

40% {
  -webkit-transform: scale3d(0.75, 1.25, 1);
  transform: scale3d(0.75, 1.25, 1);
}

50% {
  -webkit-transform: scale3d(1.15, 0.85, 1);
  transform: scale3d(1.15, 0.85, 1);
}

65% {
  -webkit-transform: scale3d(.95, 1.05, 1);
  transform: scale3d(.95, 1.05, 1);
}

75% {
  -webkit-transform: scale3d(1.05, .95, 1);
  transform: scale3d(1.05, .95, 1);
}

to {
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}
}

.rubberBand {
-webkit-animation-name: rubberBand;
animation-name: rubberBand;
}

@-webkit-keyframes shake {
from, to {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

10%, 30%, 50%, 70%, 90% {
  -webkit-transform: translate3d(-10px, 0, 0);
  transform: translate3d(-10px, 0, 0);
}

20%, 40%, 60%, 80% {
  -webkit-transform: translate3d(10px, 0, 0);
  transform: translate3d(10px, 0, 0);
}
}

@keyframes shake {
from, to {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

10%, 30%, 50%, 70%, 90% {
  -webkit-transform: translate3d(-10px, 0, 0);
  transform: translate3d(-10px, 0, 0);
}

20%, 40%, 60%, 80% {
  -webkit-transform: translate3d(10px, 0, 0);
  transform: translate3d(10px, 0, 0);
}
}

.shake {
-webkit-animation-name: shake;
animation-name: shake;
}

@-webkit-keyframes headShake {
0% {
  -webkit-transform: translateX(0);
  transform: translateX(0);
}

6.5% {
  -webkit-transform: translateX(-6px) rotateY(-9deg);
  transform: translateX(-6px) rotateY(-9deg);
}

18.5% {
  -webkit-transform: translateX(5px) rotateY(7deg);
  transform: translateX(5px) rotateY(7deg);
}

31.5% {
  -webkit-transform: translateX(-3px) rotateY(-5deg);
  transform: translateX(-3px) rotateY(-5deg);
}

43.5% {
  -webkit-transform: translateX(2px) rotateY(3deg);
  transform: translateX(2px) rotateY(3deg);
}

50% {
  -webkit-transform: translateX(0);
  transform: translateX(0);
}
}

@keyframes headShake {
0% {
  -webkit-transform: translateX(0);
  transform: translateX(0);
}

6.5% {
  -webkit-transform: translateX(-6px) rotateY(-9deg);
  transform: translateX(-6px) rotateY(-9deg);
}

18.5% {
  -webkit-transform: translateX(5px) rotateY(7deg);
  transform: translateX(5px) rotateY(7deg);
}

31.5% {
  -webkit-transform: translateX(-3px) rotateY(-5deg);
  transform: translateX(-3px) rotateY(-5deg);
}

43.5% {
  -webkit-transform: translateX(2px) rotateY(3deg);
  transform: translateX(2px) rotateY(3deg);
}

50% {
  -webkit-transform: translateX(0);
  transform: translateX(0);
}
}

.headShake {
-webkit-animation-timing-function: ease-in-out;
animation-timing-function: ease-in-out;
-webkit-animation-name: headShake;
animation-name: headShake;
}

@-webkit-keyframes swing {
20% {
  -webkit-transform: rotate3d(0, 0, 1, 15deg);
  transform: rotate3d(0, 0, 1, 15deg);
}

40% {
  -webkit-transform: rotate3d(0, 0, 1, -10deg);
  transform: rotate3d(0, 0, 1, -10deg);
}

60% {
  -webkit-transform: rotate3d(0, 0, 1, 5deg);
  transform: rotate3d(0, 0, 1, 5deg);
}

80% {
  -webkit-transform: rotate3d(0, 0, 1, -5deg);
  transform: rotate3d(0, 0, 1, -5deg);
}

to {
  -webkit-transform: rotate3d(0, 0, 1, 0deg);
  transform: rotate3d(0, 0, 1, 0deg);
}
}

@keyframes swing {
20% {
  -webkit-transform: rotate3d(0, 0, 1, 15deg);
  transform: rotate3d(0, 0, 1, 15deg);
}

40% {
  -webkit-transform: rotate3d(0, 0, 1, -10deg);
  transform: rotate3d(0, 0, 1, -10deg);
}

60% {
  -webkit-transform: rotate3d(0, 0, 1, 5deg);
  transform: rotate3d(0, 0, 1, 5deg);
}

80% {
  -webkit-transform: rotate3d(0, 0, 1, -5deg);
  transform: rotate3d(0, 0, 1, -5deg);
}

to {
  -webkit-transform: rotate3d(0, 0, 1, 0deg);
  transform: rotate3d(0, 0, 1, 0deg);
}
}

.swing {
-webkit-transform-origin: top center;
transform-origin: top center;
-webkit-animation-name: swing;
animation-name: swing;
}

@-webkit-keyframes tada {
from {
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}

10%, 20% {
  -webkit-transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);
  transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);
}

30%, 50%, 70%, 90% {
  -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
}

40%, 60%, 80% {
  -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
}

to {
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}
}

@keyframes tada {
from {
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}

10%, 20% {
  -webkit-transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);
  transform: scale3d(.9, .9, .9) rotate3d(0, 0, 1, -3deg);
}

30%, 50%, 70%, 90% {
  -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
}

40%, 60%, 80% {
  -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
}

to {
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}
}

.tada {
-webkit-animation-name: tada;
animation-name: tada;
}

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */

@-webkit-keyframes wobble {
from {
  -webkit-transform: none;
  transform: none;
}

15% {
  -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);
  transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);
}

30% {
  -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);
  transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);
}

45% {
  -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);
  transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);
}

60% {
  -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);
  transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);
}

75% {
  -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);
  transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);
}

to {
  -webkit-transform: none;
  transform: none;
}
}

@keyframes wobble {
from {
  -webkit-transform: none;
  transform: none;
}

15% {
  -webkit-transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);
  transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);
}

30% {
  -webkit-transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);
  transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);
}

45% {
  -webkit-transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);
  transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);
}

60% {
  -webkit-transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);
  transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);
}

75% {
  -webkit-transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);
  transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);
}

to {
  -webkit-transform: none;
  transform: none;
}
}

.wobble {
-webkit-animation-name: wobble;
animation-name: wobble;
}

@-webkit-keyframes jello {
from, 11.1%, to {
  -webkit-transform: none;
  transform: none;
}

22.2% {
  -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
  transform: skewX(-12.5deg) skewY(-12.5deg);
}

33.3% {
  -webkit-transform: skewX(6.25deg) skewY(6.25deg);
  transform: skewX(6.25deg) skewY(6.25deg);
}

44.4% {
  -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
  transform: skewX(-3.125deg) skewY(-3.125deg);
}

55.5% {
  -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
  transform: skewX(1.5625deg) skewY(1.5625deg);
}

66.6% {
  -webkit-transform: skewX(-0.78125deg) skewY(-0.78125deg);
  transform: skewX(-0.78125deg) skewY(-0.78125deg);
}

77.7% {
  -webkit-transform: skewX(0.390625deg) skewY(0.390625deg);
  transform: skewX(0.390625deg) skewY(0.390625deg);
}

88.8% {
  -webkit-transform: skewX(-0.1953125deg) skewY(-0.1953125deg);
  transform: skewX(-0.1953125deg) skewY(-0.1953125deg);
}
}

@keyframes jello {
from, 11.1%, to {
  -webkit-transform: none;
  transform: none;
}

22.2% {
  -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
  transform: skewX(-12.5deg) skewY(-12.5deg);
}

33.3% {
  -webkit-transform: skewX(6.25deg) skewY(6.25deg);
  transform: skewX(6.25deg) skewY(6.25deg);
}

44.4% {
  -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
  transform: skewX(-3.125deg) skewY(-3.125deg);
}

55.5% {
  -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
  transform: skewX(1.5625deg) skewY(1.5625deg);
}

66.6% {
  -webkit-transform: skewX(-0.78125deg) skewY(-0.78125deg);
  transform: skewX(-0.78125deg) skewY(-0.78125deg);
}

77.7% {
  -webkit-transform: skewX(0.390625deg) skewY(0.390625deg);
  transform: skewX(0.390625deg) skewY(0.390625deg);
}

88.8% {
  -webkit-transform: skewX(-0.1953125deg) skewY(-0.1953125deg);
  transform: skewX(-0.1953125deg) skewY(-0.1953125deg);
}
}

.jello {
-webkit-animation-name: jello;
animation-name: jello;
-webkit-transform-origin: center;
transform-origin: center;
}

@-webkit-keyframes bounceIn {
from, 20%, 40%, 60%, 80%, to {
  -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
}

0% {
  opacity: 0;
  -webkit-transform: scale3d(.3, .3, .3);
  transform: scale3d(.3, .3, .3);
}

20% {
  -webkit-transform: scale3d(1.1, 1.1, 1.1);
  transform: scale3d(1.1, 1.1, 1.1);
}

40% {
  -webkit-transform: scale3d(.9, .9, .9);
  transform: scale3d(.9, .9, .9);
}

60% {
  opacity: 1;
  -webkit-transform: scale3d(1.03, 1.03, 1.03);
  transform: scale3d(1.03, 1.03, 1.03);
}

80% {
  -webkit-transform: scale3d(.97, .97, .97);
  transform: scale3d(.97, .97, .97);
}

to {
  opacity: 1;
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}
}

@keyframes bounceIn {
from, 20%, 40%, 60%, 80%, to {
  -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
}

0% {
  opacity: 0;
  -webkit-transform: scale3d(.3, .3, .3);
  transform: scale3d(.3, .3, .3);
}

20% {
  -webkit-transform: scale3d(1.1, 1.1, 1.1);
  transform: scale3d(1.1, 1.1, 1.1);
}

40% {
  -webkit-transform: scale3d(.9, .9, .9);
  transform: scale3d(.9, .9, .9);
}

60% {
  opacity: 1;
  -webkit-transform: scale3d(1.03, 1.03, 1.03);
  transform: scale3d(1.03, 1.03, 1.03);
}

80% {
  -webkit-transform: scale3d(.97, .97, .97);
  transform: scale3d(.97, .97, .97);
}

to {
  opacity: 1;
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}
}

.bounceIn {
-webkit-animation-name: bounceIn;
animation-name: bounceIn;
}

@-webkit-keyframes bounceInDown {
from, 60%, 75%, 90%, to {
  -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
}

0% {
  opacity: 0;
  -webkit-transform: translate3d(0, -3000px, 0);
  transform: translate3d(0, -3000px, 0);
}

60% {
  opacity: 1;
  -webkit-transform: translate3d(0, 25px, 0);
  transform: translate3d(0, 25px, 0);
}

75% {
  -webkit-transform: translate3d(0, -10px, 0);
  transform: translate3d(0, -10px, 0);
}

90% {
  -webkit-transform: translate3d(0, 5px, 0);
  transform: translate3d(0, 5px, 0);
}

to {
  -webkit-transform: none;
  transform: none;
}
}

@keyframes bounceInDown {
from, 60%, 75%, 90%, to {
  -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
}

0% {
  opacity: 0;
  -webkit-transform: translate3d(0, -3000px, 0);
  transform: translate3d(0, -3000px, 0);
}

60% {
  opacity: 1;
  -webkit-transform: translate3d(0, 25px, 0);
  transform: translate3d(0, 25px, 0);
}

75% {
  -webkit-transform: translate3d(0, -10px, 0);
  transform: translate3d(0, -10px, 0);
}

90% {
  -webkit-transform: translate3d(0, 5px, 0);
  transform: translate3d(0, 5px, 0);
}

to {
  -webkit-transform: none;
  transform: none;
}
}

.bounceInDown {
-webkit-animation-name: bounceInDown;
animation-name: bounceInDown;
}

@-webkit-keyframes bounceInLeft {
from, 60%, 75%, 90%, to {
  -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
}

0% {
  opacity: 0;
  -webkit-transform: translate3d(-3000px, 0, 0);
  transform: translate3d(-3000px, 0, 0);
}

60% {
  opacity: 1;
  -webkit-transform: translate3d(25px, 0, 0);
  transform: translate3d(25px, 0, 0);
}

75% {
  -webkit-transform: translate3d(-10px, 0, 0);
  transform: translate3d(-10px, 0, 0);
}

90% {
  -webkit-transform: translate3d(5px, 0, 0);
  transform: translate3d(5px, 0, 0);
}

to {
  -webkit-transform: none;
  transform: none;
}
}

@keyframes bounceInLeft {
from, 60%, 75%, 90%, to {
  -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
}

0% {
  opacity: 0;
  -webkit-transform: translate3d(-3000px, 0, 0);
  transform: translate3d(-3000px, 0, 0);
}

60% {
  opacity: 1;
  -webkit-transform: translate3d(25px, 0, 0);
  transform: translate3d(25px, 0, 0);
}

75% {
  -webkit-transform: translate3d(-10px, 0, 0);
  transform: translate3d(-10px, 0, 0);
}

90% {
  -webkit-transform: translate3d(5px, 0, 0);
  transform: translate3d(5px, 0, 0);
}

to {
  -webkit-transform: none;
  transform: none;
}
}

.bounceInLeft {
-webkit-animation-name: bounceInLeft;
animation-name: bounceInLeft;
}

@-webkit-keyframes bounceInRight {
from, 60%, 75%, 90%, to {
  -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
}

from {
  opacity: 0;
  -webkit-transform: translate3d(3000px, 0, 0);
  transform: translate3d(3000px, 0, 0);
}

60% {
  opacity: 1;
  -webkit-transform: translate3d(-25px, 0, 0);
  transform: translate3d(-25px, 0, 0);
}

75% {
  -webkit-transform: translate3d(10px, 0, 0);
  transform: translate3d(10px, 0, 0);
}

90% {
  -webkit-transform: translate3d(-5px, 0, 0);
  transform: translate3d(-5px, 0, 0);
}

to {
  -webkit-transform: none;
  transform: none;
}
}

@keyframes bounceInRight {
from, 60%, 75%, 90%, to {
  -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
}

from {
  opacity: 0;
  -webkit-transform: translate3d(3000px, 0, 0);
  transform: translate3d(3000px, 0, 0);
}

60% {
  opacity: 1;
  -webkit-transform: translate3d(-25px, 0, 0);
  transform: translate3d(-25px, 0, 0);
}

75% {
  -webkit-transform: translate3d(10px, 0, 0);
  transform: translate3d(10px, 0, 0);
}

90% {
  -webkit-transform: translate3d(-5px, 0, 0);
  transform: translate3d(-5px, 0, 0);
}

to {
  -webkit-transform: none;
  transform: none;
}
}

.bounceInRight {
-webkit-animation-name: bounceInRight;
animation-name: bounceInRight;
}

@-webkit-keyframes bounceInUp {
from, 60%, 75%, 90%, to {
  -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
}

from {
  opacity: 0;
  -webkit-transform: translate3d(0, 3000px, 0);
  transform: translate3d(0, 3000px, 0);
}

60% {
  opacity: 1;
  -webkit-transform: translate3d(0, -20px, 0);
  transform: translate3d(0, -20px, 0);
}

75% {
  -webkit-transform: translate3d(0, 10px, 0);
  transform: translate3d(0, 10px, 0);
}

90% {
  -webkit-transform: translate3d(0, -5px, 0);
  transform: translate3d(0, -5px, 0);
}

to {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
}

@keyframes bounceInUp {
from, 60%, 75%, 90%, to {
  -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
}

from {
  opacity: 0;
  -webkit-transform: translate3d(0, 3000px, 0);
  transform: translate3d(0, 3000px, 0);
}

60% {
  opacity: 1;
  -webkit-transform: translate3d(0, -20px, 0);
  transform: translate3d(0, -20px, 0);
}

75% {
  -webkit-transform: translate3d(0, 10px, 0);
  transform: translate3d(0, 10px, 0);
}

90% {
  -webkit-transform: translate3d(0, -5px, 0);
  transform: translate3d(0, -5px, 0);
}

to {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
}

.bounceInUp {
-webkit-animation-name: bounceInUp;
animation-name: bounceInUp;
}

@-webkit-keyframes bounceOut {
20% {
  -webkit-transform: scale3d(.9, .9, .9);
  transform: scale3d(.9, .9, .9);
}

50%, 55% {
  opacity: 1;
  -webkit-transform: scale3d(1.1, 1.1, 1.1);
  transform: scale3d(1.1, 1.1, 1.1);
}

to {
  opacity: 0;
  -webkit-transform: scale3d(.3, .3, .3);
  transform: scale3d(.3, .3, .3);
}
}

@keyframes bounceOut {
20% {
  -webkit-transform: scale3d(.9, .9, .9);
  transform: scale3d(.9, .9, .9);
}

50%, 55% {
  opacity: 1;
  -webkit-transform: scale3d(1.1, 1.1, 1.1);
  transform: scale3d(1.1, 1.1, 1.1);
}

to {
  opacity: 0;
  -webkit-transform: scale3d(.3, .3, .3);
  transform: scale3d(.3, .3, .3);
}
}

.bounceOut {
-webkit-animation-name: bounceOut;
animation-name: bounceOut;
}

@-webkit-keyframes bounceOutDown {
20% {
  -webkit-transform: translate3d(0, 10px, 0);
  transform: translate3d(0, 10px, 0);
}

40%, 45% {
  opacity: 1;
  -webkit-transform: translate3d(0, -20px, 0);
  transform: translate3d(0, -20px, 0);
}

to {
  opacity: 0;
  -webkit-transform: translate3d(0, 2000px, 0);
  transform: translate3d(0, 2000px, 0);
}
}

@keyframes bounceOutDown {
20% {
  -webkit-transform: translate3d(0, 10px, 0);
  transform: translate3d(0, 10px, 0);
}

40%, 45% {
  opacity: 1;
  -webkit-transform: translate3d(0, -20px, 0);
  transform: translate3d(0, -20px, 0);
}

to {
  opacity: 0;
  -webkit-transform: translate3d(0, 2000px, 0);
  transform: translate3d(0, 2000px, 0);
}
}

.bounceOutDown {
-webkit-animation-name: bounceOutDown;
animation-name: bounceOutDown;
}

@-webkit-keyframes bounceOutLeft {
20% {
  opacity: 1;
  -webkit-transform: translate3d(20px, 0, 0);
  transform: translate3d(20px, 0, 0);
}

to {
  opacity: 0;
  -webkit-transform: translate3d(-2000px, 0, 0);
  transform: translate3d(-2000px, 0, 0);
}
}

@keyframes bounceOutLeft {
20% {
  opacity: 1;
  -webkit-transform: translate3d(20px, 0, 0);
  transform: translate3d(20px, 0, 0);
}

to {
  opacity: 0;
  -webkit-transform: translate3d(-2000px, 0, 0);
  transform: translate3d(-2000px, 0, 0);
}
}

.bounceOutLeft {
-webkit-animation-name: bounceOutLeft;
animation-name: bounceOutLeft;
}

@-webkit-keyframes bounceOutRight {
20% {
  opacity: 1;
  -webkit-transform: translate3d(-20px, 0, 0);
  transform: translate3d(-20px, 0, 0);
}

to {
  opacity: 0;
  -webkit-transform: translate3d(2000px, 0, 0);
  transform: translate3d(2000px, 0, 0);
}
}

@keyframes bounceOutRight {
20% {
  opacity: 1;
  -webkit-transform: translate3d(-20px, 0, 0);
  transform: translate3d(-20px, 0, 0);
}

to {
  opacity: 0;
  -webkit-transform: translate3d(2000px, 0, 0);
  transform: translate3d(2000px, 0, 0);
}
}

.bounceOutRight {
-webkit-animation-name: bounceOutRight;
animation-name: bounceOutRight;
}

@-webkit-keyframes bounceOutUp {
20% {
  -webkit-transform: translate3d(0, -10px, 0);
  transform: translate3d(0, -10px, 0);
}

40%, 45% {
  opacity: 1;
  -webkit-transform: translate3d(0, 20px, 0);
  transform: translate3d(0, 20px, 0);
}

to {
  opacity: 0;
  -webkit-transform: translate3d(0, -2000px, 0);
  transform: translate3d(0, -2000px, 0);
}
}

@keyframes bounceOutUp {
20% {
  -webkit-transform: translate3d(0, -10px, 0);
  transform: translate3d(0, -10px, 0);
}

40%, 45% {
  opacity: 1;
  -webkit-transform: translate3d(0, 20px, 0);
  transform: translate3d(0, 20px, 0);
}

to {
  opacity: 0;
  -webkit-transform: translate3d(0, -2000px, 0);
  transform: translate3d(0, -2000px, 0);
}
}

.bounceOutUp {
-webkit-animation-name: bounceOutUp;
animation-name: bounceOutUp;
}

@-webkit-keyframes fadeIn {
from {
  opacity: 0;
}

to {
  opacity: 1;
}
}

@keyframes fadeIn {
from {
  opacity: 0;
}

to {
  opacity: 1;
}
}

.fadeIn {
-webkit-animation-name: fadeIn;
animation-name: fadeIn;
}

@-webkit-keyframes fadeInDown {
from {
  opacity: 0;
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

@keyframes fadeInDown {
from {
  opacity: 0;
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

.fadeInDown {
-webkit-animation-name: fadeInDown;
animation-name: fadeInDown;
}

@-webkit-keyframes fadeInDownBig {
from {
  opacity: 0;
  -webkit-transform: translate3d(0, -2000px, 0);
  transform: translate3d(0, -2000px, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

@keyframes fadeInDownBig {
from {
  opacity: 0;
  -webkit-transform: translate3d(0, -2000px, 0);
  transform: translate3d(0, -2000px, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

.fadeInDownBig {
-webkit-animation-name: fadeInDownBig;
animation-name: fadeInDownBig;
}

@-webkit-keyframes fadeInLeft {
from {
  opacity: 0;
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

@keyframes fadeInLeft {
from {
  opacity: 0;
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

.fadeInLeft {
-webkit-animation-name: fadeInLeft;
animation-name: fadeInLeft;
}

@-webkit-keyframes fadeInLeftBig {
from {
  opacity: 0;
  -webkit-transform: translate3d(-2000px, 0, 0);
  transform: translate3d(-2000px, 0, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

@keyframes fadeInLeftBig {
from {
  opacity: 0;
  -webkit-transform: translate3d(-2000px, 0, 0);
  transform: translate3d(-2000px, 0, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

.fadeInLeftBig {
-webkit-animation-name: fadeInLeftBig;
animation-name: fadeInLeftBig;
}

@-webkit-keyframes fadeInRight {
from {
  opacity: 0;
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

@keyframes fadeInRight {
from {
  opacity: 0;
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

.fadeInRight {
-webkit-animation-name: fadeInRight;
animation-name: fadeInRight;
}

@-webkit-keyframes fadeInRightBig {
from {
  opacity: 0;
  -webkit-transform: translate3d(2000px, 0, 0);
  transform: translate3d(2000px, 0, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

@keyframes fadeInRightBig {
from {
  opacity: 0;
  -webkit-transform: translate3d(2000px, 0, 0);
  transform: translate3d(2000px, 0, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

.fadeInRightBig {
-webkit-animation-name: fadeInRightBig;
animation-name: fadeInRightBig;
}

@-webkit-keyframes fadeInUp {
from {
  opacity: 0;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

@keyframes fadeInUp {
from {
  opacity: 0;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

.fadeInUp {
-webkit-animation-name: fadeInUp;
animation-name: fadeInUp;
}

@-webkit-keyframes fadeInUpBig {
from {
  opacity: 0;
  -webkit-transform: translate3d(0, 2000px, 0);
  transform: translate3d(0, 2000px, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

@keyframes fadeInUpBig {
from {
  opacity: 0;
  -webkit-transform: translate3d(0, 2000px, 0);
  transform: translate3d(0, 2000px, 0);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

.fadeInUpBig {
-webkit-animation-name: fadeInUpBig;
animation-name: fadeInUpBig;
}

@-webkit-keyframes fadeOut {
from {
  opacity: 1;
}

to {
  opacity: 0;
}
}

@keyframes fadeOut {
from {
  opacity: 1;
}

to {
  opacity: 0;
}
}

.fadeOut {
-webkit-animation-name: fadeOut;
animation-name: fadeOut;
}

@-webkit-keyframes fadeOutDown {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}
}

@keyframes fadeOutDown {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}
}

.fadeOutDown {
-webkit-animation-name: fadeOutDown;
animation-name: fadeOutDown;
}

@-webkit-keyframes fadeOutDownBig {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(0, 2000px, 0);
  transform: translate3d(0, 2000px, 0);
}
}

@keyframes fadeOutDownBig {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(0, 2000px, 0);
  transform: translate3d(0, 2000px, 0);
}
}

.fadeOutDownBig {
-webkit-animation-name: fadeOutDownBig;
animation-name: fadeOutDownBig;
}

@-webkit-keyframes fadeOutLeft {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
}
}

@keyframes fadeOutLeft {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
}
}

.fadeOutLeft {
-webkit-animation-name: fadeOutLeft;
animation-name: fadeOutLeft;
}

@-webkit-keyframes fadeOutLeftBig {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(-2000px, 0, 0);
  transform: translate3d(-2000px, 0, 0);
}
}

@keyframes fadeOutLeftBig {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(-2000px, 0, 0);
  transform: translate3d(-2000px, 0, 0);
}
}

.fadeOutLeftBig {
-webkit-animation-name: fadeOutLeftBig;
animation-name: fadeOutLeftBig;
}

@-webkit-keyframes fadeOutRight {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}
}

@keyframes fadeOutRight {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}
}

.fadeOutRight {
-webkit-animation-name: fadeOutRight;
animation-name: fadeOutRight;
}

@-webkit-keyframes fadeOutRightBig {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(2000px, 0, 0);
  transform: translate3d(2000px, 0, 0);
}
}

@keyframes fadeOutRightBig {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(2000px, 0, 0);
  transform: translate3d(2000px, 0, 0);
}
}

.fadeOutRightBig {
-webkit-animation-name: fadeOutRightBig;
animation-name: fadeOutRightBig;
}

@-webkit-keyframes fadeOutUp {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
}
}

@keyframes fadeOutUp {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
}
}

.fadeOutUp {
-webkit-animation-name: fadeOutUp;
animation-name: fadeOutUp;
}

@-webkit-keyframes fadeOutUpBig {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(0, -2000px, 0);
  transform: translate3d(0, -2000px, 0);
}
}

@keyframes fadeOutUpBig {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(0, -2000px, 0);
  transform: translate3d(0, -2000px, 0);
}
}

.fadeOutUpBig {
-webkit-animation-name: fadeOutUpBig;
animation-name: fadeOutUpBig;
}

@-webkit-keyframes flip {
from {
  -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -360deg);
  transform: perspective(400px) rotate3d(0, 1, 0, -360deg);
  -webkit-animation-timing-function: ease-out;
  animation-timing-function: ease-out;
}

40% {
  -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);
  transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);
  -webkit-animation-timing-function: ease-out;
  animation-timing-function: ease-out;
}

50% {
  -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);
  transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
}

80% {
  -webkit-transform: perspective(400px) scale3d(.95, .95, .95);
  transform: perspective(400px) scale3d(.95, .95, .95);
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
}

to {
  -webkit-transform: perspective(400px);
  transform: perspective(400px);
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
}
}

@keyframes flip {
from {
  -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -360deg);
  transform: perspective(400px) rotate3d(0, 1, 0, -360deg);
  -webkit-animation-timing-function: ease-out;
  animation-timing-function: ease-out;
}

40% {
  -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);
  transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);
  -webkit-animation-timing-function: ease-out;
  animation-timing-function: ease-out;
}

50% {
  -webkit-transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);
  transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
}

80% {
  -webkit-transform: perspective(400px) scale3d(.95, .95, .95);
  transform: perspective(400px) scale3d(.95, .95, .95);
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
}

to {
  -webkit-transform: perspective(400px);
  transform: perspective(400px);
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
}
}

.animated.flip {
-webkit-backface-visibility: visible;
backface-visibility: visible;
-webkit-animation-name: flip;
animation-name: flip;
}

@-webkit-keyframes flipInX {
from {
  -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
  transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
  opacity: 0;
}

40% {
  -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
  transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
}

60% {
  -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
  transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
  opacity: 1;
}

80% {
  -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
}

to {
  -webkit-transform: perspective(400px);
  transform: perspective(400px);
}
}

@keyframes flipInX {
from {
  -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
  transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
  opacity: 0;
}

40% {
  -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
  transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
}

60% {
  -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
  transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
  opacity: 1;
}

80% {
  -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
}

to {
  -webkit-transform: perspective(400px);
  transform: perspective(400px);
}
}

.flipInX {
-webkit-backface-visibility: visible !important;
backface-visibility: visible !important;
-webkit-animation-name: flipInX;
animation-name: flipInX;
}

@-webkit-keyframes flipInY {
from {
  -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
  transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
  opacity: 0;
}

40% {
  -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
  transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
}

60% {
  -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
  transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
  opacity: 1;
}

80% {
  -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
  transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
}

to {
  -webkit-transform: perspective(400px);
  transform: perspective(400px);
}
}

@keyframes flipInY {
from {
  -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
  transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
  opacity: 0;
}

40% {
  -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
  transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
  -webkit-animation-timing-function: ease-in;
  animation-timing-function: ease-in;
}

60% {
  -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
  transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
  opacity: 1;
}

80% {
  -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
  transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
}

to {
  -webkit-transform: perspective(400px);
  transform: perspective(400px);
}
}

.flipInY {
-webkit-backface-visibility: visible !important;
backface-visibility: visible !important;
-webkit-animation-name: flipInY;
animation-name: flipInY;
}

@-webkit-keyframes flipOutX {
from {
  -webkit-transform: perspective(400px);
  transform: perspective(400px);
}

30% {
  -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
  transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
  opacity: 1;
}

to {
  -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
  transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
  opacity: 0;
}
}

@keyframes flipOutX {
from {
  -webkit-transform: perspective(400px);
  transform: perspective(400px);
}

30% {
  -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
  transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
  opacity: 1;
}

to {
  -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
  transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
  opacity: 0;
}
}

.flipOutX {
-webkit-animation-name: flipOutX;
animation-name: flipOutX;
-webkit-backface-visibility: visible !important;
backface-visibility: visible !important;
}

@-webkit-keyframes flipOutY {
from {
  -webkit-transform: perspective(400px);
  transform: perspective(400px);
}

30% {
  -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -15deg);
  transform: perspective(400px) rotate3d(0, 1, 0, -15deg);
  opacity: 1;
}

to {
  -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
  transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
  opacity: 0;
}
}

@keyframes flipOutY {
from {
  -webkit-transform: perspective(400px);
  transform: perspective(400px);
}

30% {
  -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -15deg);
  transform: perspective(400px) rotate3d(0, 1, 0, -15deg);
  opacity: 1;
}

to {
  -webkit-transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
  transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
  opacity: 0;
}
}

.flipOutY {
-webkit-backface-visibility: visible !important;
backface-visibility: visible !important;
-webkit-animation-name: flipOutY;
animation-name: flipOutY;
}

@-webkit-keyframes lightSpeedIn {
from {
  -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);
  transform: translate3d(100%, 0, 0) skewX(-30deg);
  opacity: 0;
}

60% {
  -webkit-transform: skewX(20deg);
  transform: skewX(20deg);
  opacity: 1;
}

80% {
  -webkit-transform: skewX(-5deg);
  transform: skewX(-5deg);
  opacity: 1;
}

to {
  -webkit-transform: none;
  transform: none;
  opacity: 1;
}
}

@keyframes lightSpeedIn {
from {
  -webkit-transform: translate3d(100%, 0, 0) skewX(-30deg);
  transform: translate3d(100%, 0, 0) skewX(-30deg);
  opacity: 0;
}

60% {
  -webkit-transform: skewX(20deg);
  transform: skewX(20deg);
  opacity: 1;
}

80% {
  -webkit-transform: skewX(-5deg);
  transform: skewX(-5deg);
  opacity: 1;
}

to {
  -webkit-transform: none;
  transform: none;
  opacity: 1;
}
}

.lightSpeedIn {
-webkit-animation-name: lightSpeedIn;
animation-name: lightSpeedIn;
-webkit-animation-timing-function: ease-out;
animation-timing-function: ease-out;
}

@-webkit-keyframes lightSpeedOut {
from {
  opacity: 1;
}

to {
  -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);
  transform: translate3d(100%, 0, 0) skewX(30deg);
  opacity: 0;
}
}

@keyframes lightSpeedOut {
from {
  opacity: 1;
}

to {
  -webkit-transform: translate3d(100%, 0, 0) skewX(30deg);
  transform: translate3d(100%, 0, 0) skewX(30deg);
  opacity: 0;
}
}

.lightSpeedOut {
-webkit-animation-name: lightSpeedOut;
animation-name: lightSpeedOut;
-webkit-animation-timing-function: ease-in;
animation-timing-function: ease-in;
}

@-webkit-keyframes rotateIn {
from {
  -webkit-transform-origin: center;
  transform-origin: center;
  -webkit-transform: rotate3d(0, 0, 1, -200deg);
  transform: rotate3d(0, 0, 1, -200deg);
  opacity: 0;
}

to {
  -webkit-transform-origin: center;
  transform-origin: center;
  -webkit-transform: none;
  transform: none;
  opacity: 1;
}
}

@keyframes rotateIn {
from {
  -webkit-transform-origin: center;
  transform-origin: center;
  -webkit-transform: rotate3d(0, 0, 1, -200deg);
  transform: rotate3d(0, 0, 1, -200deg);
  opacity: 0;
}

to {
  -webkit-transform-origin: center;
  transform-origin: center;
  -webkit-transform: none;
  transform: none;
  opacity: 1;
}
}

.rotateIn {
-webkit-animation-name: rotateIn;
animation-name: rotateIn;
}

@-webkit-keyframes rotateInDownLeft {
from {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: rotate3d(0, 0, 1, -45deg);
  transform: rotate3d(0, 0, 1, -45deg);
  opacity: 0;
}

to {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: none;
  transform: none;
  opacity: 1;
}
}

@keyframes rotateInDownLeft {
from {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: rotate3d(0, 0, 1, -45deg);
  transform: rotate3d(0, 0, 1, -45deg);
  opacity: 0;
}

to {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: none;
  transform: none;
  opacity: 1;
}
}

.rotateInDownLeft {
-webkit-animation-name: rotateInDownLeft;
animation-name: rotateInDownLeft;
}

@-webkit-keyframes rotateInDownRight {
from {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  -webkit-transform: rotate3d(0, 0, 1, 45deg);
  transform: rotate3d(0, 0, 1, 45deg);
  opacity: 0;
}

to {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  -webkit-transform: none;
  transform: none;
  opacity: 1;
}
}

@keyframes rotateInDownRight {
from {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  -webkit-transform: rotate3d(0, 0, 1, 45deg);
  transform: rotate3d(0, 0, 1, 45deg);
  opacity: 0;
}

to {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  -webkit-transform: none;
  transform: none;
  opacity: 1;
}
}

.rotateInDownRight {
-webkit-animation-name: rotateInDownRight;
animation-name: rotateInDownRight;
}

@-webkit-keyframes rotateInUpLeft {
from {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: rotate3d(0, 0, 1, 45deg);
  transform: rotate3d(0, 0, 1, 45deg);
  opacity: 0;
}

to {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: none;
  transform: none;
  opacity: 1;
}
}

@keyframes rotateInUpLeft {
from {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: rotate3d(0, 0, 1, 45deg);
  transform: rotate3d(0, 0, 1, 45deg);
  opacity: 0;
}

to {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: none;
  transform: none;
  opacity: 1;
}
}

.rotateInUpLeft {
-webkit-animation-name: rotateInUpLeft;
animation-name: rotateInUpLeft;
}

@-webkit-keyframes rotateInUpRight {
from {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  -webkit-transform: rotate3d(0, 0, 1, -90deg);
  transform: rotate3d(0, 0, 1, -90deg);
  opacity: 0;
}

to {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  -webkit-transform: none;
  transform: none;
  opacity: 1;
}
}

@keyframes rotateInUpRight {
from {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  -webkit-transform: rotate3d(0, 0, 1, -90deg);
  transform: rotate3d(0, 0, 1, -90deg);
  opacity: 0;
}

to {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  -webkit-transform: none;
  transform: none;
  opacity: 1;
}
}

.rotateInUpRight {
-webkit-animation-name: rotateInUpRight;
animation-name: rotateInUpRight;
}

@-webkit-keyframes rotateOut {
from {
  -webkit-transform-origin: center;
  transform-origin: center;
  opacity: 1;
}

to {
  -webkit-transform-origin: center;
  transform-origin: center;
  -webkit-transform: rotate3d(0, 0, 1, 200deg);
  transform: rotate3d(0, 0, 1, 200deg);
  opacity: 0;
}
}

@keyframes rotateOut {
from {
  -webkit-transform-origin: center;
  transform-origin: center;
  opacity: 1;
}

to {
  -webkit-transform-origin: center;
  transform-origin: center;
  -webkit-transform: rotate3d(0, 0, 1, 200deg);
  transform: rotate3d(0, 0, 1, 200deg);
  opacity: 0;
}
}

.rotateOut {
-webkit-animation-name: rotateOut;
animation-name: rotateOut;
}

@-webkit-keyframes rotateOutDownLeft {
from {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  opacity: 1;
}

to {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: rotate3d(0, 0, 1, 45deg);
  transform: rotate3d(0, 0, 1, 45deg);
  opacity: 0;
}
}

@keyframes rotateOutDownLeft {
from {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  opacity: 1;
}

to {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: rotate3d(0, 0, 1, 45deg);
  transform: rotate3d(0, 0, 1, 45deg);
  opacity: 0;
}
}

.rotateOutDownLeft {
-webkit-animation-name: rotateOutDownLeft;
animation-name: rotateOutDownLeft;
}

@-webkit-keyframes rotateOutDownRight {
from {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  opacity: 1;
}

to {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  -webkit-transform: rotate3d(0, 0, 1, -45deg);
  transform: rotate3d(0, 0, 1, -45deg);
  opacity: 0;
}
}

@keyframes rotateOutDownRight {
from {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  opacity: 1;
}

to {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  -webkit-transform: rotate3d(0, 0, 1, -45deg);
  transform: rotate3d(0, 0, 1, -45deg);
  opacity: 0;
}
}

.rotateOutDownRight {
-webkit-animation-name: rotateOutDownRight;
animation-name: rotateOutDownRight;
}

@-webkit-keyframes rotateOutUpLeft {
from {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  opacity: 1;
}

to {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: rotate3d(0, 0, 1, -45deg);
  transform: rotate3d(0, 0, 1, -45deg);
  opacity: 0;
}
}

@keyframes rotateOutUpLeft {
from {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  opacity: 1;
}

to {
  -webkit-transform-origin: left bottom;
  transform-origin: left bottom;
  -webkit-transform: rotate3d(0, 0, 1, -45deg);
  transform: rotate3d(0, 0, 1, -45deg);
  opacity: 0;
}
}

.rotateOutUpLeft {
-webkit-animation-name: rotateOutUpLeft;
animation-name: rotateOutUpLeft;
}

@-webkit-keyframes rotateOutUpRight {
from {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  opacity: 1;
}

to {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  -webkit-transform: rotate3d(0, 0, 1, 90deg);
  transform: rotate3d(0, 0, 1, 90deg);
  opacity: 0;
}
}

@keyframes rotateOutUpRight {
from {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  opacity: 1;
}

to {
  -webkit-transform-origin: right bottom;
  transform-origin: right bottom;
  -webkit-transform: rotate3d(0, 0, 1, 90deg);
  transform: rotate3d(0, 0, 1, 90deg);
  opacity: 0;
}
}

.rotateOutUpRight {
-webkit-animation-name: rotateOutUpRight;
animation-name: rotateOutUpRight;
}

@-webkit-keyframes hinge {
0% {
  -webkit-transform-origin: top left;
  transform-origin: top left;
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
}

20%, 60% {
  -webkit-transform: rotate3d(0, 0, 1, 80deg);
  transform: rotate3d(0, 0, 1, 80deg);
  -webkit-transform-origin: top left;
  transform-origin: top left;
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
}

40%, 80% {
  -webkit-transform: rotate3d(0, 0, 1, 60deg);
  transform: rotate3d(0, 0, 1, 60deg);
  -webkit-transform-origin: top left;
  transform-origin: top left;
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
  opacity: 1;
}

to {
  -webkit-transform: translate3d(0, 700px, 0);
  transform: translate3d(0, 700px, 0);
  opacity: 0;
}
}

@keyframes hinge {
0% {
  -webkit-transform-origin: top left;
  transform-origin: top left;
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
}

20%, 60% {
  -webkit-transform: rotate3d(0, 0, 1, 80deg);
  transform: rotate3d(0, 0, 1, 80deg);
  -webkit-transform-origin: top left;
  transform-origin: top left;
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
}

40%, 80% {
  -webkit-transform: rotate3d(0, 0, 1, 60deg);
  transform: rotate3d(0, 0, 1, 60deg);
  -webkit-transform-origin: top left;
  transform-origin: top left;
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
  opacity: 1;
}

to {
  -webkit-transform: translate3d(0, 700px, 0);
  transform: translate3d(0, 700px, 0);
  opacity: 0;
}
}

.hinge {
-webkit-animation-name: hinge;
animation-name: hinge;
}

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */

@-webkit-keyframes rollIn {
from {
  opacity: 0;
  -webkit-transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);
  transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

@keyframes rollIn {
from {
  opacity: 0;
  -webkit-transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);
  transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);
}

to {
  opacity: 1;
  -webkit-transform: none;
  transform: none;
}
}

.rollIn {
-webkit-animation-name: rollIn;
animation-name: rollIn;
}

/* originally authored by Nick Pettit - https://github.com/nickpettit/glide */

@-webkit-keyframes rollOut {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);
  transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);
}
}

@keyframes rollOut {
from {
  opacity: 1;
}

to {
  opacity: 0;
  -webkit-transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);
  transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);
}
}

.rollOut {
-webkit-animation-name: rollOut;
animation-name: rollOut;
}

@-webkit-keyframes zoomIn {
from {
  opacity: 0;
  -webkit-transform: scale3d(.3, .3, .3);
  transform: scale3d(.3, .3, .3);
}

50% {
  opacity: 1;
}
}

@keyframes zoomIn {
from {
  opacity: 0;
  -webkit-transform: scale3d(.3, .3, .3);
  transform: scale3d(.3, .3, .3);
}

50% {
  opacity: 1;
}
}

.zoomIn {
-webkit-animation-name: zoomIn;
animation-name: zoomIn;
}

@-webkit-keyframes zoomInDown {
from {
  opacity: 0;
  -webkit-transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
  transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
  -webkit-animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

60% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
  transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
  -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
}
}

@keyframes zoomInDown {
from {
  opacity: 0;
  -webkit-transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
  transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
  -webkit-animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

60% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
  transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
  -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
}
}

.zoomInDown {
-webkit-animation-name: zoomInDown;
animation-name: zoomInDown;
}

@-webkit-keyframes zoomInLeft {
from {
  opacity: 0;
  -webkit-transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
  transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
  -webkit-animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

60% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
  transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
  -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
}
}

@keyframes zoomInLeft {
from {
  opacity: 0;
  -webkit-transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
  transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
  -webkit-animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

60% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
  transform: scale3d(.475, .475, .475) translate3d(10px, 0, 0);
  -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
}
}

.zoomInLeft {
-webkit-animation-name: zoomInLeft;
animation-name: zoomInLeft;
}

@-webkit-keyframes zoomInRight {
from {
  opacity: 0;
  -webkit-transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
  transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
  -webkit-animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

60% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
  transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
  -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
}
}

@keyframes zoomInRight {
from {
  opacity: 0;
  -webkit-transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
  transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
  -webkit-animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

60% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
  transform: scale3d(.475, .475, .475) translate3d(-10px, 0, 0);
  -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
}
}

.zoomInRight {
-webkit-animation-name: zoomInRight;
animation-name: zoomInRight;
}

@-webkit-keyframes zoomInUp {
from {
  opacity: 0;
  -webkit-transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
  transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
  -webkit-animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

60% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
  transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
  -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
}
}

@keyframes zoomInUp {
from {
  opacity: 0;
  -webkit-transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
  transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
  -webkit-animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

60% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
  transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
  -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
}
}

.zoomInUp {
-webkit-animation-name: zoomInUp;
animation-name: zoomInUp;
}

@-webkit-keyframes zoomOut {
from {
  opacity: 1;
}

50% {
  opacity: 0;
  -webkit-transform: scale3d(.3, .3, .3);
  transform: scale3d(.3, .3, .3);
}

to {
  opacity: 0;
}
}

@keyframes zoomOut {
from {
  opacity: 1;
}

50% {
  opacity: 0;
  -webkit-transform: scale3d(.3, .3, .3);
  transform: scale3d(.3, .3, .3);
}

to {
  opacity: 0;
}
}

.zoomOut {
-webkit-animation-name: zoomOut;
animation-name: zoomOut;
}

@-webkit-keyframes zoomOutDown {
40% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
  transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
  -webkit-animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

to {
  opacity: 0;
  -webkit-transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
  transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
  -webkit-transform-origin: center bottom;
  transform-origin: center bottom;
  -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
}
}

@keyframes zoomOutDown {
40% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
  transform: scale3d(.475, .475, .475) translate3d(0, -60px, 0);
  -webkit-animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

to {
  opacity: 0;
  -webkit-transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
  transform: scale3d(.1, .1, .1) translate3d(0, 2000px, 0);
  -webkit-transform-origin: center bottom;
  transform-origin: center bottom;
  -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
}
}

.zoomOutDown {
-webkit-animation-name: zoomOutDown;
animation-name: zoomOutDown;
}

@-webkit-keyframes zoomOutLeft {
40% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);
  transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);
}

to {
  opacity: 0;
  -webkit-transform: scale(.1) translate3d(-2000px, 0, 0);
  transform: scale(.1) translate3d(-2000px, 0, 0);
  -webkit-transform-origin: left center;
  transform-origin: left center;
}
}

@keyframes zoomOutLeft {
40% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);
  transform: scale3d(.475, .475, .475) translate3d(42px, 0, 0);
}

to {
  opacity: 0;
  -webkit-transform: scale(.1) translate3d(-2000px, 0, 0);
  transform: scale(.1) translate3d(-2000px, 0, 0);
  -webkit-transform-origin: left center;
  transform-origin: left center;
}
}

.zoomOutLeft {
-webkit-animation-name: zoomOutLeft;
animation-name: zoomOutLeft;
}

@-webkit-keyframes zoomOutRight {
40% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);
  transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);
}

to {
  opacity: 0;
  -webkit-transform: scale(.1) translate3d(2000px, 0, 0);
  transform: scale(.1) translate3d(2000px, 0, 0);
  -webkit-transform-origin: right center;
  transform-origin: right center;
}
}

@keyframes zoomOutRight {
40% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);
  transform: scale3d(.475, .475, .475) translate3d(-42px, 0, 0);
}

to {
  opacity: 0;
  -webkit-transform: scale(.1) translate3d(2000px, 0, 0);
  transform: scale(.1) translate3d(2000px, 0, 0);
  -webkit-transform-origin: right center;
  transform-origin: right center;
}
}

.zoomOutRight {
-webkit-animation-name: zoomOutRight;
animation-name: zoomOutRight;
}

@-webkit-keyframes zoomOutUp {
40% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
  transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
  -webkit-animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

to {
  opacity: 0;
  -webkit-transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
  transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
  -webkit-transform-origin: center bottom;
  transform-origin: center bottom;
  -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
}
}

@keyframes zoomOutUp {
40% {
  opacity: 1;
  -webkit-transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
  transform: scale3d(.475, .475, .475) translate3d(0, 60px, 0);
  -webkit-animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

to {
  opacity: 0;
  -webkit-transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
  transform: scale3d(.1, .1, .1) translate3d(0, -2000px, 0);
  -webkit-transform-origin: center bottom;
  transform-origin: center bottom;
  -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);
}
}

.zoomOutUp {
-webkit-animation-name: zoomOutUp;
animation-name: zoomOutUp;
}

@-webkit-keyframes slideInDown {
from {
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
  visibility: visible;
}

to {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
}

@keyframes slideInDown {
from {
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
  visibility: visible;
}

to {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
}

.slideInDown {
-webkit-animation-name: slideInDown;
animation-name: slideInDown;
}

@-webkit-keyframes slideInLeft {
from {
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
  visibility: visible;
}

to {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
}

@keyframes slideInLeft {
from {
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
  visibility: visible;
}

to {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
}

.slideInLeft {
-webkit-animation-name: slideInLeft;
animation-name: slideInLeft;
}

@-webkit-keyframes slideInRight {
from {
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
  visibility: visible;
}

to {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
}

@keyframes slideInRight {
from {
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
  visibility: visible;
}

to {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
}

.slideInRight {
-webkit-animation-name: slideInRight;
animation-name: slideInRight;
}

@-webkit-keyframes slideInUp {
from {
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
  visibility: visible;
}

to {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
}

@keyframes slideInUp {
from {
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
  visibility: visible;
}

to {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
}

.slideInUp {
-webkit-animation-name: slideInUp;
animation-name: slideInUp;
}

@-webkit-keyframes slideOutDown {
from {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

to {
  visibility: hidden;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}
}

@keyframes slideOutDown {
from {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

to {
  visibility: hidden;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
}
}

.slideOutDown {
-webkit-animation-name: slideOutDown;
animation-name: slideOutDown;
}

@-webkit-keyframes slideOutLeft {
from {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

to {
  visibility: hidden;
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
}
}

@keyframes slideOutLeft {
from {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

to {
  visibility: hidden;
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
}
}

.slideOutLeft {
-webkit-animation-name: slideOutLeft;
animation-name: slideOutLeft;
}

@-webkit-keyframes slideOutRight {
from {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

to {
  visibility: hidden;
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}
}

@keyframes slideOutRight {
from {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

to {
  visibility: hidden;
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}
}

.slideOutRight {
-webkit-animation-name: slideOutRight;
animation-name: slideOutRight;
}

@-webkit-keyframes slideOutUp {
from {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

to {
  visibility: hidden;
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
}
}

@keyframes slideOutUp {
from {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

to {
  visibility: hidden;
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
}
}

.slideOutUp {
-webkit-animation-name: slideOutUp;
animation-name: slideOutUp;
}


/* @import url(https://fonts.googleapis.com/css?family=Rubik);
* {
  font-family: 'Rubik';
} */

.modal-dialog {
    max-width: 800px;
    margin: 30px auto;
}

.modal-body p {
  margin-top: 30px;
}

.modal-body {
position:relative;
padding:0px;
}
.close {
position:absolute;
right:-30px;
top:0;
z-index:999;
font-size:2rem;
font-weight: normal;
color:#fff;
opacity:1;
}
.team .quote .list-group-item {
border-color: #f5f5f5;
}
section.section-2 {
background-color: #111117;

}
.sub-title p{
font-family: 'Rubik';
}
.counter-item h4 {
color: #fff !important;
margin: 20px 0;
  font-family: 'Rubik';
}
.counter-item p {
color: #eee;
  font-family: 'Rubik';
}
#about-2 .site-title {
margin-bottom: 20px;
  text-align: left;
}
#about-2 .intro p{
color: #eeeeee;
  font-family: 'Rubik';
}
.section-2 .site-title h2{
  color: #fff;
  font-family: 'Rubik';
}
.radial span,.radial{
color: #004599 !important;
font-size: 36px;
font-weight: bold;
  font-family: 'Rubik';
}
section.section-1 {
  padding-bottom: 120px;
}
section.section-2 {
  padding: 120px 0;
}
p:first-child {
margin-top: 0;
}
.team .quote {
width: 100%;
height: auto;
display: flex;
align-items: center;
justify-content: center;
padding: 20px;
background-color: #004599;
border-radius: 4px;
color: var(--primary-bg-color-2);
}
.list-group-item {
background: none !important;
padding-left: 0 !important;
}

.list-group .list-group-item .icon {
color: var(--primary-color);
margin-right: 15px;
display: flex;
align-items: center;
justify-content: center;
color: #fff;
}
.list-group-item .icon {
font-size: 34px;
text-align: left;
}
.list-group-item a {
font-size: 30px;
color: #fff;
margin-right: 20px;
}
.team .quote h4 {
margin-top: 0;
color: #fff;
  font-family: 'Rubik';
}
.team .quote p {
color:#fff;
font-size: 14px;
  font-family: 'Rubik';
}
.team .quote .list-group-item {
border-color: #f5f5f5;
}
.about-mision p {
color: #777;
  line-height: 30px;
  font-size: 16px;
  font-family: 'Rubik';
}
.modal-body {
  font-size: 24px;
  font-family: 'Rubik';
}
.modal-title {
  font-size: 30px;
  font-family: 'Rubik';
}
.modal-footer button {
  font-family: 'Rubik';
  background: #004599;
  border: none;
}
.list-group-content strong {
  cursor: pointer;
}
.site-title h2 {
  text-align: left;
}
.section-1 .modal-content {
  padding: 20px 30px;
}
/* Medium devices (tablets, 768px and up)*/
@media only screen and (max-width: 480px) and (min-width: 320px)  {
.site-title h2 {
  font-size: 30px;
}
  section.section-2{
  padding: 20px;
  }
  #about-2 .site-title{
      padding-left: 0;
      text-align: left !important;
  }
  .site-title h2, .section-2 .site-title h2{
      font-size: 30px !important;
  }

  .documentories_area > ul > li:nth-child(2n+1) .single_documentories_wrapper{
      width: 100% !important;
     
  }
  .documentories_area > ul > li:nth-child(2n) .documentories_content_wrapper{
      border-radius: inherit !important;
  }
  .documentories_area > ul > li:nth-child(2n) .single_documentories_wrapper{
      width: 100% !important;
      
  }
  .documentories_area > ul > li:nth-child(2n+1) .documentories_content_wrapper{
      border-radius: inherit !important;
  }
  .p-0.pr-md-5.about-mision {
      padding: 0 20px !important;
  }   
  .row.intro {
      padding: 0 0;
  }

  .site-title{
      text-align: left !important;
      padding-left: 10px;
  }
  .site-title h4::before{
      display: none;
  }
  .mb-40{
      margin-top: 40px;
  }
  .counter-item {
      margin-left: 10px;
  }
 .close{
  right: 0;
  color: #000 !important;
  border: none !important;
}
.modal-header .close {
  margin:0 !important;
}
 
 
}
@media only screen and (max-width: 575px) and (min-width: 481px)  {
  .documentories_area > ul > li:nth-child(2n+1) .single_documentories_wrapper{
  width: 100% !important;
}
.documentories_area > ul > li:nth-child(2n) .single_documentories_wrapper{
  width: 100% !important;
}
.site-title{
      padding-left: 20px;
      margin-bottom: 30px;
      margin-top: 30px;
  }
  section.section-2 {
      padding: 30px;
  }
  #about-2 .site-title {
    padding-left: 0;
  }
  .list-group-content {
  width: 100%;
  }
}
/* Medium devices (tablets, 768px and up)*/
@media only screen and (max-width: 767px) and (min-width: 576px)  {
   .documentories_area > ul > li:nth-child(2n+1) .single_documentories_wrapper{
  width: 100% !important;
}
.documentories_area > ul > li:nth-child(2n) .single_documentories_wrapper{
  width: 100% !important;
}
.list-group-content {
  width: 100%;
  }
  .modal-dialog {
  max-width: 630px;
  }
  .modal-body {
      font-size: 20px;
      font-family: 'Rubik';
  }
  .section-1 .site-title {
      margin-top: 60px;
  }

}
/* Medium devices (tablets, 768px and up)*/
@media only screen and (max-width: 991px) and (min-width: 768px)  {
  .documentories_area > ul > li:nth-child(2n+1) .single_documentories_wrapper{
  width: 100% !important;
}
.documentories_area > ul > li:nth-child(2n) .single_documentories_wrapper{
  width: 100% !important;
}
 section.section-2 {
      padding: 30px;
  }
  
  .documentories_area > ul > li:nth-child(2n) .documentories_img{
      padding-top: 13px !important;
  }
  .list-group-content {
      width: 100%;
  }
  .modal-dialog {
  max-width: 630px;
  }
  .modal-body{
      font-size: 20px;
      font-family: 'Rubik';
  }

}
/* Large devices (desktops, 992px and up)*/
@media only screen and (max-width: 1199px) and (min-width: 992px)  {


}
/* Extra large devices (large desktops, 1200px and up)*/

@media only screen and (max-width: 1600px) and (min-width: 1200px)  {

}

/** About us Page Area  Start **/
p{
  font-family: 'Rubik';
}
.corporate-video-tab ul li a {
color: #fff;
  font-family: 'Rubik';
}
.no-gutters {
padding: 0;
}
.site-title {
text-align: left;
margin-bottom: 60px;

}
.site-title h4 {
font-size: 18px;
position: relative;
color: #0070ba;
display:inline-block;
  font-family: 'Rubik';
}
.site-title h2 {
font-size: 48px;
color: #222;
  font-family: 'Rubik';	
  margin-bottom: 0;
  font-weight: 700;
}
.site-title h4::before {
position: absolute;
width: 63px;
height: 2px;
background: #0070ba;
top: 10px;
left: 110%;
content: "";
}
.corporate-video-tab ul {
margin-bottom: 40px;
border: none;
}
.corporate-video {
padding: 100px 0px;
background: #f5f5f5;
}
.corporate-video-tab ul li {
background: #111117;
}
.corporate-video-tab ul li a.active{
background: #0070ba !important;
color: #fff !important;
border: none;
  font-family: 'Rubik';
  
}
.corporate-video-tab ul li a {
color: #fff;
  font-family: 'Rubik';
}
.nav-tabs .nav-link{
border: none;
}
#video_block_1 .video-inner{
position: relative;
width: 100%;
padding: 260px 0px;
background-size: cover;
background-repeat: no-repeat;
background-position: center;
text-align: center;
}
#video_block_1 .video-inner a {
position: relative;
display: inline-block;
font-size: 24px;
width: 54px;
height: 54px;
line-height: 54px;
background: rgba(255,255,255,0.95);
text-align: center;
border-radius: 50%;
}

#video_block_1 .video-inner a:after, 
#video_block_1 .video-inner a:before {
width: 70px;
height: 70px;
border-radius: 50%;
background: transparent;
position: absolute;
top: 50%;
left: 50%;
-webkit-transform: translate(-50%, -50%);
transform: translate(-50%, -50%);
-webkit-animation-delay: .9s;
animation-delay: .9s;
content: "";
position: absolute;
-webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.6);
box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.6);
-webkit-animation: ripple 3s infinite;
animation: ripple 3s infinite;
-webkit-transition: all .4s ease;
transition: all .4s ease;
}

#video_block_1 .video-inner a:after {
-webkit-animation-delay: .6s;
animation-delay: .6s;
}

@-webkit-keyframes ripple {
70% {
  -webkit-box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);
      box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);
}
100% {
  -webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
      box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
}
}
@keyframes ripple {
70% {
  -webkit-box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);
      box-shadow: 0 0 0 40px rgba(255, 255, 255, 0);
}
100% {
  -webkit-box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
      box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
}
}

/*-----------------------------------------------------------------------------------*/
/*    5.     documentories_area CSS
/*-----------------------------------------------------------------------------------*/
.documentories_area {
  padding: 100px 0;
}
.previous_timelin, .next_timelin {
background: #0070ba;
color: #fff;
width: 90px;
height: 50px;
line-height: 50px;
text-align: center;

}
.previous_timelin {
border-radius: 50px 0 0  50px;
margin-right: 20px;
}
.next_timelin {
border-radius: 0 50px 50px 0px;
margin-left: 20px;
}
.previous_timelin a{
color: #fff;
  font-family: 'Rubik';
  display: block;
}
.next_timelin a{
color: #fff;
font-family: 'Rubik';
display: block;
}
.documentories_area {
  position: relative;
}
.documentories_area > ul {
  box-sizing: border-box;
  display: table;
  height: 100%;
  margin-bottom: 0;
  padding: 0;
  position: relative;
  width: 100%;
}
.documentories_area > ul:before {
  background: #fae1e4 none repeat scroll 0 0;
  content: "";
  height: 100%;
  left: calc(50% - 1px);
  position: absolute;
  top: 0;
  width: 2px;
}
.documentories_area > ul > li {
  overflow: hidden;
  position: relative;
}
.documentories_area > ul > li:nth-child(2n+1) .single_documentories_wrapper {
  float: right;
  width: 47%;
}
.documentories_area > ul > li:nth-child(2n) .single_documentories_wrapper {
  float: left;
  width: 47%;
}
.documentories_area > ul > li .documentories_year {
  background-color: #0070ba;
  border-radius: 33px;
  color: #fefefe;
  font-family: "Poppins",sans-serif;
  font-size: 14px;
  font-weight: 600;
  height: 30px;
  left: calc(50% - 45px);
  line-height: 33px;
  position: absolute;
  text-align: center;
  width: 92px;
}
.documentories_content_wrapper {
  background-color: #3c1525;
  margin-top: 58px;
  margin-bottom: 55px;
  padding: 10px;
  display: table;
  position: relative;
}
.documentories_area > ul > li:nth-child(2n+1) .documentories_content_wrapper {
  border-radius: 0 108px 108px 0;
   height: 140px;
}
.documentories_area > ul > li:nth-child(2n) .documentories_content_wrapper {
  border-radius: 180px 0 0 180px;
  height: 140px;
}
.documentories_area > ul > li:nth-child(2n+1) .documentories_text {
  text-align: left;
}
.documentories_text {
  color: #fefefe;
  float: left;
  font-size: 14px;
  font-weight: 300;
  line-height: 23px;
  padding-bottom: 5px;
  padding-left: 10px;
  vertical-align: middle;
  width: calc(100% - 161px);
  font-family: 'Rubik';
  padding-top: 10px;
}
.documentories_text h3 {
  font-family: 'Rubik';
  font-size: 15px;
  font-weight: 600;
  padding-bottom: 14px;
  padding-top: 8px;
  text-transform: uppercase;
}
.documentories_text h3 a {
  color: #fefefe;
}
.documentories_img {
  display: table-cell;
  float: right;
  padding-top: 15px;
  
}
.documentories_area > ul > li:nth-child(2n+1) .documentories_img img {
  border-radius: 0 50px 50px 0;
}
.documentories_area > ul > li:nth-child(2n) .documentories_img img {
  border-radius: 50px 0 0 50px;
}
.documentories_area > ul > li:nth-child(2n) .documentories_text {
  padding-right: 0;
}

.documentories_month {
  padding-right: 30px;
  position: absolute;
  top: 55%;
  color: #0070ba;
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
}
.documentories_area > ul > li:nth-child(2n+1) .documentories_month {
  padding-right: 30px;
  right: 50%;
}
.documentories_area > ul > li:nth-child(2n) .documentories_month {
  padding-left: 30px;
  left: 50%;
}
.documentories_content_wrapper:before {
  position: absolute;
  content: "";
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #fae1e4;
  border: 2px solid #3c1525;
  top: 73%;
}
.documentories_area > ul > li:nth-child(2n+1) .documentories_content_wrapper:before {
  left: -40px;
}
.documentories_area > ul > li:nth-child(2n) .documentories_content_wrapper:before {
  right: -39px;
}
.documentories_content_wrapper::after {
  border-bottom: 20px solid transparent;
  border-right: 50px solid #563341;
  bottom: 11px;
  content: "";
  position: absolute;
  -webkit-transform: rotate(23deg);
  transform: rotate(23deg);
  z-index: -1;
  
}
.documentories_area > ul > li:nth-child(2n+1) .documentories_content_wrapper:after {
  left: -44px;
}
.documentories_area > ul > li:nth-child(2n) .documentories_content_wrapper:after {
  border-left: 50px solid #563341;
  border-right: medium none transparent;
  bottom: 12px;
  right: -42px;
  -webkit-transform: rotate(-30deg);
  transform: rotate(-30deg);
}

.documentories_img > img {
  width: initial;
}
.documentories_area > ul > li:nth-child(2n) .documentories_text {
  float: right;
  padding-right: 0;
  width: calc(100% - 160px);
}
.documentories_area > ul > li:nth-child(2n) .documentories_img {
  display: table-cell;
  float: left;
  padding-top: 15px;
  vertical-align: middle;
}

/* This code is for button */

.previous {
  background-color: #0070ba;
  height: 30px;
  left: calc(50% - 75px);
  bottom: 0;
  position: absolute;
  width: 90px;
  text-align: center;
  display: block;
  line-height: 30px;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  text-transform: capitalize;
}
.previous a {
  color: #fefefe;
}

/* This code is for hover */

.single_documentories_wrapper:hover .documentories_content_wrapper:before {
  border: 2px solid #0070ba;
}
.single_documentories_wrapper:hover .documentories_content_wrapper {
  background-color: #0070ba;
}
.single_documentories_wrapper:hover .documentories_content_wrapper:after {
  border-right: 50px solid #0070ba;
}
.documentories_area > ul > li:nth-child(2n) > .single_documentories_wrapper:hover .documentories_content_wrapper:after {
  border-left: 50px solid #0070ba;
}

/* Extra small devices (portrait phones, less than 576px)*/
/* No media query since this is the default in Bootstrap*/
</style>